import { createSlice } from "@reduxjs/toolkit";
import { drmtDailyFilterPayload } from "../../constData/filterRequestPayloadDrmtDaily";

const drmDailyTableFilterSlice = createSlice({
  name: "drmDailyTableFilter",
  initialState: {
    dailyTableFilter: drmtDailyFilterPayload,
  },
  reducers: {
    setDrmTableFilter: (state, action) => {
      state.dailyTableFilter = { ...state.dailyTableFilter, ...action.payload };
    },
    resetDrmTableFilter: (state) => {
      state.dailyTableFilter = {
        ...drmtDailyFilterPayload,
        divisions: state.dailyTableFilter.divisions,
        originCountries: state.dailyTableFilter.originCountries,
        destinationCountries: state.dailyTableFilter.destinationCountries,
      };
    },
  },
});

export const { setDrmTableFilter, resetDrmTableFilter } =
  drmDailyTableFilterSlice.actions;
export default drmDailyTableFilterSlice.reducer;
